import { Doc } from '@ankr.com/ui';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { ChainMenuItem } from '../ChainMenuItem';
import { docsMenuItemTranslation } from './translation';

interface DocsMenuItemProps {
  closeMenu: () => void;
  link: string;
}

export const DocsMenuItem = ({ closeMenu, link }: DocsMenuItemProps) => {
  const { keys, t } = useTranslation(docsMenuItemTranslation);

  const onClick = () => {
    closeMenu();

    window.open(link, '_blank');
  };

  return (
    <ChainMenuItem Icon={Doc} onClick={onClick}>
      {t(keys.docs)}
    </ChainMenuItem>
  );
};
